import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader, Dropdown } from 'semantic-ui-react';
import { EventTypesStore, EventTypeDto } from 'stores/configuration/events-workflow/event-types-store';

import {
  ChangeRequestReasonDto,
  ChangeRequestReasonStore,
  RequestReasonDto
} from '../../../../../stores/configuration/events-n-requests/request-reasons-store';
import { nameof } from '../../../../../utils/object';

interface ChangeRequestReasonViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  changeRequestReason?: ChangeRequestReasonStore;
  currentRequestReason: RequestReasonDto;
  eventTypes: EventTypesStore;
}

// tslint:disable-next-line:no-empty-interface
interface ChangeRequestReasonViewState {}

@connect(['changeRequestReason', ChangeRequestReasonStore], ['eventTypes', EventTypesStore])
class ChangeRequestReasonView extends React.Component<ChangeRequestReasonViewProps, ChangeRequestReasonViewState> {
  private get changeRequestReasonStore() {
    return this.props.changeRequestReason;
  }

  constructor(props: ChangeRequestReasonViewProps) {
    super(props);

    this.changeRequestReasonStore.state.result = null;

    this.changeRequestReasonStore.change({
      id: this.props.currentRequestReason.id,
      name: this.props.currentRequestReason.name,
      eventTypes: this.props.currentRequestReason.eventTypes.map(item => item.originalEventTypeId)
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps: ChangeRequestReasonViewProps) {
    if (this.changeRequestReasonStore.state.result && this.changeRequestReasonStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  loadEventTypes = () => {
    this.props.eventTypes.getAllAsync({
      searchQuery: '',
      filter: ['active eq true', 'EventTypeConfiguration/RolesThatCreateRequests/any()'],
      skip: 0,
      take: 100000,
      orderBy: [{ direction: 'Descending', field: nameof<EventTypeDto>('name'), useProfile: false }]
    });
  };

  componentDidMount() {
    this.loadEventTypes();
  }

  @autobind
  private onChangeItem() {
    this.changeRequestReasonStore.update();
  }

  @autobind
  private onCancelChangeItem() {
    this.changeRequestReasonStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    const change = {};
    change[property] = value;
    this.changeRequestReasonStore.change({ ...this.changeRequestReasonStore.state.item, ...change });
  }

  public render() {
    const { t } = this.props as any;
    const { result } = this.changeRequestReasonStore.state;
    const eventTypesOptions = this.props.eventTypes.state.items.map(({ item }) => ({
      key: item.originalEventTypeId,
      text: item.name,
      value: item.originalEventTypeId
    }));

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelChangeItem} closeOnDimmerClick={false}>
        <Dimmer active={this.changeRequestReasonStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('Edit Request Reason')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.changeRequestReasonStore.state.result && !this.changeRequestReasonStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.changeRequestReasonStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.changeRequestReasonStore.state.item && (
              <Form>
                <Form.Field>
                  <Form.Input
                    required
                    error={!this.changeRequestReasonStore.state.item.name}
                    fluid
                    label={t('Request Reason')}
                    placeholder={t('Name')}
                    value={this.changeRequestReasonStore.state.item.name}
                    onChange={(e, { value }) => this.handleValue(nameof<ChangeRequestReasonDto>('name'), value)}
                  />
                </Form.Field>
                <Form.Field widths="equal">
                  <div className={`field inline configuration-event-n-request__modal__element`}>
                    <label>{t('Event types')}</label>
                    <Dropdown
                      placeholder={t('Event types')}
                      search
                      selection
                      multiple
                      closeOnChange
                      closeOnBlur
                      closeOnEscape
                      selectOnNavigation
                      error={
                        result &&
                        !result.isSuccess &&
                        (result.messages || []).any(x => x.propertyName === nameof<ChangeRequestReasonDto>('eventTypes'))
                      }
                      options={eventTypesOptions}
                      value={this.changeRequestReasonStore.state.item.eventTypes}
                      onChange={(e, { value }) => this.handleValue(nameof<ChangeRequestReasonDto>('eventTypes'), value)}
                    />
                  </div>
                </Form.Field>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button className="basic" onClick={this.onCancelChangeItem}>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onChangeItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(ChangeRequestReasonView);
